var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"textAlign":"right"}},[_c('a-button',{staticClass:"submit-audit",staticStyle:{"width":"100%"},on:{"click":_vm.emitEvent}},[_vm._v(_vm._s(_vm.instance.btName))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }